module.exports = __webpack_public_path__ + "img/bg_arrange_successful.d8bb2fff.png";